import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { PaySafe } from '../../../dtos/pay-safe';
import { API_CLIENT_SERVICE_IMPL, IAPIClientService, PaySafeReferenceWithOrderCodes } from 'shared';
@Injectable({
    providedIn: 'root',
})
export class DailyReviewService {
    constructor(@Inject(API_CLIENT_SERVICE_IMPL) private _apiClient: IAPIClientService) {}

    public getCashPayments(userID: string): Observable<PaySafe> {
        return this._apiClient.get<PaySafe>(
            `daily-review/get-cash-payments/${userID}`
        );
    }

    public savePaySafeReferenceWithOrderCodes(
        reference: string,
        orderCodes: string
    ): Observable<HttpResponse<void>> {
        const paySafeReferenceWithOrderCodes: PaySafeReferenceWithOrderCodes = {
            reference: reference,
            orderCodes: orderCodes,
        };
        return this._apiClient.postWithResponse<void>(
            `daily-review/save-pay-safe-reference-with-order-codes`,
            paySafeReferenceWithOrderCodes
        );
    }
}
